var e={50:"#F7F8F9",100:"#eff2f4",200:"#dfe4e9",300:"#C7D0D8",400:"#b0bcc8",500:"#98A7B7",600:"#607890",700:"#546A7F",800:"#435465",900:"#303C48"};export{e as default};
